import mondaySdk from 'monday-sdk-js';
import { MONDAY_API_VERSION } from '../../constants/constants';

const monday = mondaySdk();
monday.setApiVersion(MONDAY_API_VERSION);

export default monday;
